import shopifyGenericDefaults from '../shopify-generic/config.js';

const vehicleTabsConfig = [
  {
    title: 'Vehicle',
    fields: {
      base: ['Year', 'Make', 'Model', 'Submodel', 'Engine'],
      extra: [],
    },
  },
];

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  Widgets: [
    ...shopifyGenericDefaults.Widgets,
    {
      name: 'FitmentTableTab',
      type: 'FitmentTable',
      location: '.tab-hozizoltal .nav-link[href="#fitment-tab"]',
      template: 'fitmentSearch/fitmentTableTab',
    },
    {
      name: 'HomeVehicleWidget_tabs',
      type: 'VehicleTabs',
      location: {
        selector: '#cm-home-vehicle-widget-tabs',
        class: 'container cm_vehicle-widget__home cm_vehicle-tabs__home',
      },
      template: 'fitmentSearch/vehicleTabs',
      tabs: vehicleTabsConfig,
    },
    {
      name: 'VehicleTabs',
      columnBreakpoint: 770,
      tabs: vehicleTabsConfig,
    },
    {
      name: 'DialogVehicleWidget_tabs',
      type: 'VehicleTabs',
      tabs: vehicleTabsConfig,
    },
  ],
};
